@import "src/helpers/ScreenSizes.scss";
@import "src/styles/PrimaryActionMixins.scss";

:host {
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
  min-width: 0;
}

.storeCard {
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
  color: #39393a;
  font-family: "Inter";
}

.storeCardScrollableContent {
  box-sizing: border-box;
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding: 0 16px 0 2px;
  scrollbar-color: #c5c5ca transparent;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
}

.storeCardScrollableContent::-webkit-scrollbar {
  width: 6px;
}

.storeCardScrollableContent::-webkit-scrollbar-thumb {
  background-color: #c5c5ca;
  border-radius: 6px;
}

.storeCardScrollableContent::-webkit-scrollbar-track {
  background: transparent;
}

.storeCardMessage {
  display: block;
  margin-bottom: 24px;
}

.payairPaymentSheetOverlay store-card,
.payairPaymentSheetOverlay .storeCard,
.payairPaymentSheetOverlay .storeCardScrollableContent {
  flex: 0 0 auto;
  height: auto;
}

.payairPaymentSheetOverlay .storeCardScrollableContent {
  overflow: visible;
  padding-right: 2px;
  scrollbar-gutter: auto;
}

.storeCardHeader {
  position: relative;
  flex: 0 0 auto;
  padding: 0 16px 24px 2px;
}

.storeCardMark {
  position: absolute;
  top: 0;
  right: 16px;
  display: flex;
}

.storeCardMark horizontal-mark {
  --srci-horizontal-mark-height: 24px;
}

.storeCardTitle {
  margin: 0;
  padding-right: 120px;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
}

.storeCardDescription {
  margin: 8px 0 0;
  padding-right: 120px;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
}

.storeCardConsumer,
.storeCardConsumer consumer-info-form {
  min-width: 0;
}

.storeCardConsumer consumer-info-form {
  display: block;
  --srci-input-error-font-size: 12px;
  --srci-input-error-line-height: 17px;
}

.storeCardContactNotice {
  margin: 16px 0 0;
  color: #505260;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
}

.storeCardRememberMe {
  margin-top: 12px;
}

.storeCardRememberMe > remember-me-control {
  display: block;
}

.storeCardLegalNotice {
  box-sizing: border-box;
  margin: 12px 0 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #505260;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
}

.storeCardLegalNotice a {
  color: #4d5ef2;
  font-weight: 600;
  text-decoration: none;
}

.storeCardLegalNotice a:focus-visible {
  border-radius: 2px;
  outline: 2px solid #16182b;
  outline-offset: 2px;
}

.storeCardActions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  margin: 0;
  padding: 20px 0 max(24px, env(safe-area-inset-bottom));
}

.storeCardPrimaryAction,
.storeCardBackAction {
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  padding: 0;
  border-radius: 24px;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
}

.storeCardPrimaryAction {
  @include softDisabledPrimaryAction();

  border: 0;
  background: #16182b;
  color: #ffffff;
}

.storeCardBackAction {
  border: 0;
  background: #ffffff;
  color: #16182b;
}

.storeCardPrimaryAction:focus-visible,
.storeCardBackAction:focus-visible {
  outline: 2px solid #4d5ef2;
  outline-offset: 2px;
}

.storeCardBackAction:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

@include small() {
  .storeCardHeader {
    padding-bottom: 16px;
  }

  .storeCardMark {
    position: absolute;
    top: 4px;
    right: 16px;
  }

  .storeCardMark horizontal-mark {
    --srci-horizontal-mark-height: 16px;
  }

  .storeCardTitle {
    padding-right: 104px;
  }

  .storeCardDescription {
    margin-bottom: 0;
    padding-right: 0;
  }
}

@media (max-height: 760px) {
  .storeCardHeader {
    padding-bottom: 16px;
  }

  .storeCardContactNotice {
    margin-top: 12px;
  }

  .storeCardRememberMe,
  .storeCardLegalNotice {
    margin-top: 10px;
  }

  .storeCardActions {
    padding-top: 16px;
  }
}
